import PageHeader from "../components/PageHeader";
import PageMeta from "../components/PageMeta";
import LastReviewed from "../components/LastReviewed";
import { Link } from "react-router-dom";

export default function PrivacyPage() {
  return (
    <div data-testid="privacy-page">
      <PageMeta
        title="Privacy"
        description="How the You Are Not Alone site handles your data. Written in plain English."
        path="/privacy"
      />
      <PageHeader
        overline="Privacy"
        title="How we handle your data."
        lede="Written plainly, because you have already been asked to trust enough."
      />

      <section className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-20">
        <div className="max-w-3xl space-y-10 text-base md:text-lg text-ink-muted leading-[1.8] font-light">
          <div>
            <h2 className="font-serif text-2xl md:text-3xl text-ink leading-tight tracking-tight mb-4">
              The short version
            </h2>
            <ul className="space-y-3">
              <li>We only store data you give us directly (contact form, newsletter, story submissions).</li>
              <li>We do not use tracking cookies, analytics cookies, or advertising cookies for visitors.</li>
              <li>We never sell your data. We never share it, except with a solicitor if a court orders us to.</li>
              <li>You can ask for your data to be deleted at any time. Email <a href="mailto:info@truth4parents.com" className="text-river underline">info@truth4parents.com</a>.</li>
            </ul>
          </div>

          <div>
            <h2 className="font-serif text-2xl md:text-3xl text-ink leading-tight tracking-tight mb-4">
              What we collect and why
            </h2>
            <div className="space-y-4">
              <div>
                <strong className="text-ink font-serif text-lg block">The contact form</strong>
                When you write to us, we store your name, email, chosen enquiry type, and message. We use this only to reply, and to keep a record if the conversation continues. We send a copy of the message to our own inbox by email so we don&rsquo;t miss it.
              </div>
              <div>
                <strong className="text-ink font-serif text-lg block">The newsletter</strong>
                If you subscribe, we store your email address. We use it only to send occasional updates. Reply &ldquo;unsubscribe&rdquo; to any newsletter email and we&rsquo;ll remove you within a working day.
              </div>
              <div>
                <strong className="text-ink font-serif text-lg block">Story submissions</strong>
                If you share your story, we store what you send us. Nothing is ever published without your explicit consent. You can withdraw consent at any time and we will remove the story.
              </div>
              <div>
                <strong className="text-ink font-serif text-lg block">Admin access</strong>
                The site administrator signs in with Google. Their session is stored as an httpOnly cookie for seven days. This affects only the site administrator — no cookies are set for public visitors.
              </div>
            </div>
          </div>

          <div>
            <h2 className="font-serif text-2xl md:text-3xl text-ink leading-tight tracking-tight mb-4">
              Who processes your data
            </h2>
            <p>
              The site is hosted in the EU. Emails are sent through Resend, a transactional email provider (their privacy policy is at <a href="https://resend.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-river underline">resend.com/legal/privacy-policy</a>). We use no analytics platform. We use no advertising network.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl md:text-3xl text-ink leading-tight tracking-tight mb-4">
              Your rights (UK GDPR)
            </h2>
            <p>
              You have the right to see what data we hold on you, to correct it, to have it deleted, to restrict its processing, and to complain to the Information Commissioner&rsquo;s Office (ICO) if you believe we&rsquo;ve handled your data badly. Email us at <a href="mailto:info@truth4parents.com" className="text-river underline">info@truth4parents.com</a> and we will respond within a working month, usually much faster.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-2xl md:text-3xl text-ink leading-tight tracking-tight mb-4">
              A word on this page
            </h2>
            <p>
              This is a plain-English privacy notice, not a formal legal document. If you are a solicitor or regulator wanting a formal notice, please write and we will provide one.
            </p>
          </div>

          <div className="pt-8 border-t border-rule flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-sm font-accent text-ink-muted hover:text-ink"
            >
              ← Back to home
            </Link>
            <LastReviewed path="/privacy" />
          </div>
        </div>
      </section>
    </div>
  );
}
